import React from "react";
import {
  couponTypes
} from "../UIHelpers";

export const CouponTypeFormatter = (cellContent, row) => (
  row.type ?  couponTypes[row.type] : couponTypes[row.type]
);
